module.exports = __webpack_public_path__ + "static/media/FiraSans-Italic.a64f4d7e.ttf";